import { APP_NAME } from "../../shared_component/constants/common"
import store from "../../shared_component/utils/configureStore"
import SplitClient, { ON, USAA_FUELCARD } from "../components/Config/SplitClient"
import { routeChange, routerPaths } from "./paths"

export const SAVE_UPTO = "0.05"
export const DID = "7162454.1.1124"
export const GALLONS_LIMIT = 50
export const USAGE_COUNT = 1
export const TOTAL_LOCATION = 60000
export const USAA_AFFILIATION = "USAA"
export const FROM_WHERE_USER_CAME = "promoCode"
export const USAA_PERKS_MAINTENANCE = "USAA_PERKS_MAINTENANCE"
export const USAA_PERKS_FUEL = "USAA_PERKS_FUEL"
export const FUELCARD_STATUS = {
  in_progress: "in_progress",
  initiated: "initiated",
  pending_card_generation: "pending_card_generation",
  pending_activation: "pending_activation",
  activated: "activated",
  failed: "failed",
  blocked: "CA_BLOCKED"
}

export const PLAY_STORE_APP =
  "https://play.google.com/store/apps/details?id=com.caradvise.caradvise&hl=en_IN"
export const APP_STORE_APP = "https://apps.apple.com/in/app/caradvise/id1118606915"

export async function getFuelcardUsaaFlag() {
  const user = store.getState().user

  try {
    const usaaFuelCard = await SplitClient.getTreatment(USAA_FUELCARD, user, {
      app_name: APP_NAME
    })
    return usaaFuelCard[USAA_FUELCARD] === ON
  } catch (error) {
    console.log("Error in getFuelcardUsaaFlag", error)
  }
}

export const requestFuelcard = (history) => {
  routeChange(history, routerPaths.requestFuelCard)
}
